import { LegalDocumentView } from '../components/legal/LegalDocumentView';
import { PRIVACY_CONTENT } from '../content/privacy';
import { usePageSeo } from '../hooks/usePageSeo';
import { PAGE_SEO } from '../lib/seo';

export function PrivacyPage() {
  usePageSeo(PAGE_SEO.privacy);

  return <LegalDocumentView document={PRIVACY_CONTENT} />;
}
